<template>
    <div>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="分类名称" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('algl_alfl_xz')">
                <el-button size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="排序" align="center" type="index" width="100" />
                <el-table-column label="分类名称" align="center" prop="name" />
                <el-table-column label="案例数量" align="center" prop="mcase_num" />
                <el-table-column label="创建时间" align="center" prop="create_time" />
                <el-table-column v-if="permission('algl_alfl_bj') || permission('algl_alfl_sc')" label="操作" align="center" width="100">
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('algl_alfl_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                        <el-button v-if="permission('algl_alfl_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <FormVue ref="form" @update="search"></FormVue>
    </div>
</template>

<script>
import { list, del } from "@/api/case/category";
import listMixin from "@/mixins/list";
import FormVue from "./form.vue";

export default {
    components: { FormVue },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
            },
            module: "案例分类",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleAdd() {
            this.$refs.form.open();
        },
        handleEdit(row) {
            this.$refs.form.open(row);
        },
    },
};
</script>
